import {ApiError} from '@legit-health/backend-client';
import {ImageError, ImageValue, SimpleCarousel} from '@legit-health/ui';
import {Box, Button} from '@mui/material';
import {TFunction} from 'i18next';

export default function DiqaErrors({
  apiError,
  images,
  onClickNewImage,
  t
}: {
  apiError: ApiError;
  images: ImageValue[];
  onClickNewImage?: () => void;
  t: TFunction;
}) {
  return (
    <div>
      <Box>
        {apiError.content.data.map ? (
          <SimpleCarousel
            contentNodes={apiError.content.data.map(
              (error: {
                name: string;
                pass: boolean;
                position: number;
                isDermatological: boolean;
                qualityAcceptable: boolean;
              }) => (
                <ImageError
                  key={error.position}
                  isDermatological={error.isDermatological}
                  qualityAcceptable={error.qualityAcceptable}
                  onClickNewImage={onClickNewImage}
                  instructionButton={t('ui:diagnosticReport.imageError.instructionButton')}
                  image={images[error.position]?.file}
                  cardHeaderTitle={t('ui:diagnosticReport.imageError.cardHeaderTitle')}
                  renderCardSubheaderHeader={(instructionsKey) =>
                    t(`ui:diagnosticReport.imageError.cardSubheaderHeader.${instructionsKey}`)
                  }
                  renderErrorDescription={(instructionsKey) =>
                    t(`ui:diagnosticReport.imageError.errorDescription.${instructionsKey}`)
                  }
                  renderInstructionTitle={(instruction) =>
                    t(`ui:diagnosticReport.imageError.instructions.${instruction}.title`)
                  }
                  renderInstructionDescription={(instruction) =>
                    t(`ui:diagnosticReport.imageError.instructions.${instruction}.description`)
                  }
                  cardContentSolveProblemTitle={t(
                    'ui:diagnosticReport.imageError.cardContentSolveProblemTitle'
                  )}
                  supportButton={
                    <Button
                      target="_blank"
                      href={`mailto:${t('shared/common:contact.help.email')}?subject=Email via app.legit.health`}
                      fullWidth
                      variant="text"
                      disableElevation
                    >
                      {t('ui:diagnosticReport.imageError.supportButton')}
                    </Button>
                  }
                />
              )
            )}
          />
        ) : (
          <ImageError
            onClickNewImage={onClickNewImage}
            isDermatological={apiError.content.data.isDermatological}
            qualityAcceptable={apiError.content.data.qualityAcceptable}
            cardHeaderTitle={t('ui:diagnosticReport.imageError.cardHeaderTitle')}
            image={images[0]?.file}
            renderCardSubheaderHeader={(instructionsKey) =>
              t(`ui:diagnosticReport.imageError.cardSubheaderHeader.${instructionsKey}`)
            }
            renderErrorDescription={(instructionsKey) =>
              t(`ui:diagnosticReport.imageError.errorDescription.${instructionsKey}`)
            }
            renderInstructionTitle={(instruction) =>
              t(`ui:diagnosticReport.imageError.instructions.${instruction}.title`)
            }
            renderInstructionDescription={(instruction) =>
              t(`ui:diagnosticReport.imageError.instructions.${instruction}.description`)
            }
            cardContentSolveProblemTitle={t(
              t('ui:diagnosticReport.imageError.cardContentSolveProblemTitle')
            )}
            instructionButton={t('ui:diagnosticReport.imageError.instructionButton')}
            supportButton={
              <Button
                target="_blank"
                href={`mailto:${t('shared/common:contact.help.email')}?subject=Email via app.legit.health`}
                fullWidth
                variant="text"
                disableElevation
              >
                {t('ui:diagnosticReport.imageError.supportButton')}
              </Button>
            }
          />
        )}
      </Box>
    </div>
  );
}
